import { render, staticRenderFns } from "./land-dis-loc.vue?vue&type=template&id=cf79cfc6"
import script from "./land-dis-loc.vue?vue&type=script&lang=js"
export * from "./land-dis-loc.vue?vue&type=script&lang=js"
import style0 from "./land-dis-loc.vue?vue&type=style&index=0&id=cf79cfc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports